import { Title } from "@/features/title";
import { sliderPaths } from "@/shared/constants";
import { vars } from "@/shared/lib/theme.css";
import { Column, GlobalErrorBoundary, Row, Sidebar } from "@/shared/ui";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { ErrorBoundary } from "react-error-boundary";

export const Route = createFileRoute("/(auth)/_layout")({
	component: SidebarLayout
});

function SidebarLayout() {
	return (
		<Row style={{ alignItems: "flex-start" }}>
			<Sidebar paths={sliderPaths} />
			<Column
				style={{
					minWidth: "calc(100% - 280px)",
					height: "100vh",
					justifyContent: "flex-start",
					alignItems: "flex-start",
					paddingTop: vars.size[32],
					paddingInline: vars.size[32],
				}}
			>
				{/* 타이틀 영역 - 고정 */}
				<Column
					fullWidth
					style={{
						flexShrink: 0,
						alignItems: "flex-start",
						paddingBottom: vars.size[16]
					}}
				>
					<Title />
				</Column>
				{/* 콘텐츠 영역 - 스크롤 */}
				<Column
					fullWidth
					style={{
						flex: 1,
						overflow: "auto",
					}}
				>
					<ErrorBoundary FallbackComponent={GlobalErrorBoundary}>
						<Outlet />
					</ErrorBoundary>
				</Column>
			</Column>
		</Row>
	);
}
